import { useCallback, useContext } from 'react';
import { SectionContext } from '../../../context/SectionContext';
import SizeRestrictedButton from '../SizeRestrictedButton';
import { jsx as _jsx } from "react/jsx-runtime";
const TemplateActionButton = ({
  inDataTable,
  size,
  use = 'tertiary',
  templateActionButton,
  disabled,
  tooltip
}) => {
  const {
    isWaitingForChatResponse,
    onTemplateActionClicked
  } = useContext(SectionContext);
  const onClick = useCallback(() => {
    onTemplateActionClicked(templateActionButton, {
      inDataTable
    });
  }, [inDataTable, onTemplateActionClicked, templateActionButton]);
  return /*#__PURE__*/_jsx(SizeRestrictedButton, {
    "data-test-id": "template-action-button",
    disabled: isWaitingForChatResponse || disabled,
    onClick: onClick,
    size: size,
    truncate: true,
    use: use,
    tooltip: tooltip,
    children: templateActionButton.label
  });
};
export default TemplateActionButton;